import { STATSIG_EXPERIMENTS_BUCKETS } from '@src/config/statsig-experiments.config'
import { STATSIG_EXPERIMENTS, useStatsigExperiment } from '@src/experiments/statsig-integration'
import ContentfulProductMeasuringGuide from '@src/quince-site-common/src/domains/contentful/ContentfulMeasuringGuide'
import { ContentfulSizeChart } from '@src/quince-site-common/src/domains/contentful/ContentfulProduct'
import { MergedSizeChart } from '@src/quince-site-common/src/domains/MergedSizeChart'
import Product from '@src/quince-site-common/src/domains/Product'

import { SizeGuideV2 } from '../sizeGuideV2'

import SizeGuideV1 from './SizeGuideV1'

export interface SizeGuideProps {
  sizeChart: ContentfulSizeChart
  mergedSizeChart?: MergedSizeChart[]
  measuringGuides?: ContentfulProductMeasuringGuide[]
  wrapperClassName?: string
  showSizeChartModal: boolean
  onSizeChartModalClose: () => void
  product?: Product
}

const SizeGuide = (props: SizeGuideProps) => {
  const { experimentBucket, init } = useStatsigExperiment(STATSIG_EXPERIMENTS.PDP_SIZE_CHART_V2)
  const newDesign = experimentBucket === STATSIG_EXPERIMENTS_BUCKETS.SHOW

  if (!init) return null

  return newDesign ? <SizeGuideV2 {...props} /> : <SizeGuideV1 {...props} />
}

export default SizeGuide
